import consultancyImg from "../images/consultancy.jfif";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Consultancy() {
  // useEffect(() => {
  //   AOS.init({ duration: 1000, once: true });
  // }, []);

  const showContactForm = () => {
    document.querySelector(".contactPopUp").style.zIndex = "200";
    document.querySelector(".contactPopUp").style.display = "flex";
    setTimeout(
      () =>
        (document.querySelector(".contactPopUp").style.transform =
          "scale(0.8)"),
      20
    );
    document.querySelector(".captchaCont").style.pointerEvents = "revert";
  };

  return (
    <div className="consultancyCont">
      {/* Heading */}
      <div className="consultancyHead" data-aos="fade-down">
        <div className="textDiv flex">
          <div></div>
          <div style={{ zIndex: 1 }}>CONSULTANCY SERVICES</div>
        </div>
      </div>

      {/* Intro section */}
      <h2 data-aos="fade-up">Management Systems and Sustainability</h2>
      <p data-aos="fade-up" data-aos-delay="100">
        We provide{" "}
        <strong>Management Consultancy, Training, Internal Audit</strong> |
        Onsite, Online and Hybrid. Our consulting services give you a fresh
        perspective – customized to your organization and industry. From
        defining gaps to developing leadership, we assess strategy, processes,
        and people throughout your organization, recommending the next steps and
        helping you implement them.
      </p>
      <p data-aos="fade-up" data-aos-delay="200">
        Before we begin, our consultants also analyse potential savings to
        ensure the profitability of your project.
      </p>

      {/* Image + What we do */}
      <div className="consultancyImageBlock" data-aos="zoom-in-up">
        <div>
          <h3>What we do:</h3>
          <ul className="consultancyList">
            <li>
              <strong>Gap Analysis:</strong> Measure your organisation’s current
              systems and controls against system requirements.
            </li>
            <li>
              <strong>Action Plan:</strong> Plan key steps and milestones in the
              ISO implementation and certification process.
            </li>
            <li>
              <strong>System Development:</strong> Develop business processes,
              risk management frameworks, policies, and procedures.
            </li>
            <li>
              <strong>Implementation Support:</strong> Support to help build
              evidence of compliance with standards.
            </li>
            <li>
              <strong>Training & Skill Development:</strong> Step-by-step
              competence development for internal staff.
            </li>
            <li>
              <strong>Preparation for External Audit:</strong> Assistance with
              internal audits and management reviews.
            </li>
            <li>
              <strong>Support during External Audits:</strong> Assistance in
              applications, responses, and attending certification/accreditation
              audits.
            </li>
          </ul>
        </div>
        <img src={consultancyImg} alt="Consultancy services" />
      </div>

      {/* Verticals */}
      <h3 data-aos="fade-right">
        Some of the verticals we cater (but not limited to):
      </h3>
      <ul className="consultancyGrid" data-aos="fade-up" data-aos-delay="100">
        <li>Management Systems</li>
        <li>Occupational Health</li>
        <li>Safety</li>
        <li>Environment</li>
        <li>Survey and Inspections</li>
        <li>Laboratory Testing</li>
        <li>Technical & Skill-based</li>
        <li>Sustainability & Energy</li>
        <li>Others based on client requirements</li>
      </ul>

      {/* Sustainability Solutions */}
      <h2 data-aos="fade-left">Sustainability Solutions and Carbon Services</h2>
      <p data-aos="fade-up">
        We help organizations create a more transparent and accountable business
        environment, encouraging sustainable practices and better outcomes for
        all stakeholders. Our unique reporting solutions streamline data
        collection, consolidation, and communication, helping you create and
        publish insightful reports.
      </p>

      <ul className="consultancyList" data-aos="fade-up" data-aos-delay="150">
        <li>Business Responsibility and Sustainability Reporting (BRSR)</li>
        <li>
          Reporting as per global reporting standards (GRI, CDP, IR, UNSDG’s,
          etc.)
        </li>
        <li>Industry-Specific Standards</li>
        <li>ESG Rating (Eco Vadis, Sustainalytics, etc.)</li>
      </ul>

      <p data-aos="fade-up" data-aos-delay="200">
        We support organizations in measuring and developing their carbon
        footprint, contributing to a sustainable future while gaining
        operational and reputational benefits.
      </p>

      <ul className="consultancyList" data-aos="fade-up" data-aos-delay="300">
        <li>Corporate Carbon Footprint as per GHG Protocol & ISO 14064 -1</li>
        <li>Event Carbon Footprint</li>
        <li>Sector Specific Carbon Footprint (GCCA, WSA, etc.)</li>
        <li>GHG Accounting Web Tool</li>
        <li>Product Carbon Footprint (PCF) – ISO 14067 / ISO 14064-3</li>
        <li>Decarbonization for Carbon Neutrality & Net Zero Emission</li>
        <li>Life Cycle Assessment (LCA)</li>
        <li>Energy Audit</li>
      </ul>

      <p data-aos="fade-up" data-aos-delay="400">
        Our services include: Project development & management, GHG emissions
        accounting, gap assessment, policy & framework development, report
        development, customized trainings, and more. Our experts combine diverse
        industry experience with professional qualifications, collaborating with
        leading specialists to deliver tailored solutions.
      </p>

      {/* Contact block */}
      <div className="consultancyContact" data-aos="flip-up">
        <h3>Have questions or need more information?</h3>
        <p onClick={showContactForm}>Request for a quote</p>
      </div>
    </div>
  );
}

export default Consultancy;
